(() => {
  const selector = [
    '[data-cv-bento-reveal]',
    '.bento-hero__card',
    '.bvt-card',
    '.wl-media__card',
    '.wl-details',
    '.wl-perk',
    '.cbt__card',
    '.cbt__tile',
    '.cbt__fit',
    '.cbt__final',
    '.pb-media__card',
    '.pb-details',
    '.pb-pillar',
    '.pb-notion',
    '.pp-media__card',
    '.pp-details',
    '.pp-pillar',
    '.pp-notion',
    '.arh',
    '.ast',
    '.agl__media',
    '.afn__inner',
    '.avl__item',
    '.abs__media',
    '.aac__media',
    '.atm__card',
    '.fa__media--bento'
  ].join(',');

  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  const reveal = (entry, observer) => {
    const element = entry.target;

    if (!entry.isIntersecting) return;

    element.classList.add('cv-scroll-reveal--visible');
    observer.unobserve(element);

    const clearRevealState = () => {
      element.classList.remove('cv-scroll-reveal', 'cv-scroll-reveal--visible');
      element.style.removeProperty('--cv-scroll-reveal-delay');
    };

    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'transform') return;

      element.removeEventListener('transitionend', onTransitionEnd);
      clearRevealState();
    };

    element.addEventListener('transitionend', onTransitionEnd);

    window.setTimeout(clearRevealState, 1200);
  };

  const observer = new IntersectionObserver(
    (entries, activeObserver) => entries.forEach((entry) => reveal(entry, activeObserver)),
    { rootMargin: '0px 0px -8%', threshold: 0.12 }
  );

  const prepare = (root = document) => {
    const targets = [];

    if (root instanceof Element && root.matches(selector)) targets.push(root);
    root.querySelectorAll(selector).forEach((element) => targets.push(element));

    targets.forEach((element, index) => {
      if (element.dataset.cvScrollRevealPrepared === 'true') return;

      element.dataset.cvScrollRevealPrepared = 'true';
      element.style.setProperty('--cv-scroll-reveal-delay', `${(index % 3) * 90}ms`);
      element.classList.add('cv-scroll-reveal');
      observer.observe(element);
    });
  };

  const start = () => prepare();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
